<template>
  <div>
    <GmapMap
      :center="center"
      :zoom="zoom"
      :map-type-id="mapType"
      :options="options"
      style="height: 100%; width: 100%"
      ref="googleMaps"
    >
      <div v-if="renderLine">
        <div v-if="currentPosition.length > 0 && !disableCurrentPositionDot">
          <gmap-circle
            v-for="(path, index) in currentPosition"
            :key="`cp_${index}`"
            :center="path"
            :radius="circleRadius[currentZoomLevel]"
            :visible="true"
            v-bind:options="{
              zIndex: 3,
              fillColor: 'black',
              fillOpacity: 1.0,
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="currentRange.length > 0 && showRangeCircles">
          <gmap-circle
            v-for="(path, index) in currentRange"
            :key="`cr_${index}`"
            :center="path"
            :radius="8"
            :visible="true"
            v-bind:options="{
              fillColor: '#5491f5',
              fillOpacity: 0.8,
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="polyline && !overlayAllData">
          <gmap-polyline
            @click="lineClick($event, path)"
            v-for="(path, index) in paths"
            :key="`line_${index}`"
            :path="path"
            v-bind:options="{
              strokeColor:
                strokeColors[
                  path[0].value < lowerLimit
                    ? 0
                    : path[0].value > upperLimit
                    ? 2
                    : 1
                ],
              strokeWeight: strokeWeightPerZoomLevel[currentZoomLevel],
            }"
          >
          </gmap-polyline>
        </div>
        <div
          v-if="polyline && overlayAllData"
          v-for="(lines, index) in pathsList"
          :key="`lines_${index}`"
        >
          <gmap-polyline
            @click="test(path, index, lines)"
            v-for="(path, index) in lines"
            :key="`line_${index}`"
            :path="path"
            v-bind:options="{
              strokeColor: path[0].highlighted
                ? '#5491f5'
                : strokeColors[
                    path[0].value < lowerLimit
                      ? 0
                      : path[0].value > upperLimit
                      ? 2
                      : 1
                  ],
              strokeWeight: strokeWeightPerZoomLevel[currentZoomLevel],
            }"
          >
            {{ path }}
          </gmap-polyline>
        </div>
        <!-- <div v-if="dot && !overlayAllData">
          <gmap-circle
            @click="
              panToLocation(path);
              $emit('dotClicked', index);
            "
            v-for="(path, index) in normalizedData"
            :key="`circle_${index}`"
            :center="path"
            :radius="4"
            :visible="true"
            v-bind:options="{
              zIndex: 2,
              fillColor:
                strokeColors[
                  path.value < lowerLimit ? 0 : path.value > upperLimit ? 2 : 1
                ],
              fillOpacity: path.hideCircle ? 0.0 : 1.0,
              strokeColor: strokeColors[path.value - 1],
              strokeOpacity: 0.0,
            }"
          >
          </gmap-circle>
        </div>
        <div v-if="dot && overlayAllData">
          <div
            v-for="(survey, index) in profileData"
            :key="`circleSurvey_${index}`"
          >
            <gmap-circle
              @click="
                panToLocation(path);
                $emit('dotClicked', index);
              "
              v-for="(path, index) in survey"
              :key="`circle_${index}`"
              :center="path"
              :radius="4"
              :visible="true"
              v-bind:options="{
                fillColor:
                  strokeColors[
                    path.value < lowerLimit
                      ? 0
                      : path.value > upperLimit
                      ? 2
                      : 1
                  ],
                fillOpacity: path.hideCircle ? 0.0 : 1.0,
                strokeColor: strokeColors[path.value - 1],
                strokeOpacity: 0.0,
              }"
            >
            </gmap-circle>
          </div>
        </div> -->
        <div v-if="clustorMarkers != null">
          <gmap-cluster
            :gridSize="30"
            :zoomOnClick="true"
            :enableRetinaIcons="true"
            :minimumClusterSize="2"
            @click="handleClusterClick"
            ref="cluster"
          >
            <gmap-marker
              :key="index"
              v-for="(m, index) in clustorMarkers"
              :position="m"
              :clickable="true"
              :draggable="true"
              :title="`${m.data.id}`"
              @click="
                $emit('updatePos', m);
                showByIndex == index
                  ? (showByIndex = null)
                  : (showByIndex = index);
              "
              ref="marker"
            >
              <gmap-info-window :opened="showByIndex === index">
                <h6 class="q-my-none">
                  {{ m.data.name }}
                </h6>

                <div class="row">
                  <div class="col-12">
                    <span style="font-weight: bold">Upper Limit:</span>
                    {{
                      m.data.recordedUpperLimit
                        ? m.data.recordedUpperLimit
                        : m.data.upperLimit
                    }}
                  </div>
                  <div class="col-12">
                    <span style="font-weight: bold">Lower Limit:</span>
                    {{
                      m.data.recordedLowerLimit
                        ? m.data.recordedLowerLimit
                        : m.data.lowerLimit
                    }}
                  </div>
                  <div class="col-12">
                    <span style="font-weight: bold">Date:</span>
                    {{ formatDate(m.data.date) }}
                  </div>
                  <div class="col-12">
                    <q-btn
                      flat
                      text
                      class="full-width"
                      @click="$emit('clustorMapMarkerClicked', m.data)"
                      >{{ markerButtonLabel }}</q-btn
                    >
                  </div>
                </div>
              </gmap-info-window>
            </gmap-marker>
          </gmap-cluster>
        </div>
      </div>
    </GmapMap>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GmapCluster from "vue2-google-maps/dist/components/cluster";

export default {
  components: { GmapCluster },
  computed: {
    ...mapGetters(["selectedMergingScan"]),
  },
  props: {
    mapType: String,
    options: Object,
    center: Object,
    zoom: Number,
    source: String,
    polyline: {
      type: Boolean,
      default: false,
    },
    dot: {
      type: Boolean,
      default: false,
    },
    normalizedData: {
      type: Array,
      default: null,
    },
    upperLimit: {
      type: [Number, String],
      default: 15,
    },
    lowerLimit: {
      type: [Number, String],
      default: 10,
    },
    overlayAllData: {
      type: Boolean,
      default: false,
    },
    profileData: {
      type: Array,
      default: null,
    },
    clustorMarkers: {
      type: Array,
      default: null,
    },
    showRangeCircles: {
      type: Boolean,
      default: false,
    },
    markerButtonLabel: {
      type: String,
      default: "View Report",
    },
    disableCurrentPositionDot: {
      type: Boolean,
      default: false,
    },
    pathsMaxDistance: {
      default: null,
    },
  },
  watch: {
    normalizedData: function () {
      this.generatePaths();
    },
    profileData: function () {
      this.generatePaths();
    },
    upperLimit: function () {
      setTimeout(() => {
        this.generatePaths();
      }, 100);
    },
    lowerLimit: function () {
      setTimeout(() => {
        this.generatePaths();
      }, 100);
    },
    selectedMergingScan: function () {
      this.generatePaths();
    },
  },
  data: () => ({
    coords: {
      lng: 10,
      lat: 10,
    },
    paths: [],
    pathsList: [],
    renderLine: false,
    strokeColors: ["#008000", "#eb9c34", "#eb4034"],
    mapsApi: null,
    currentPosition: [],
    currentRange: [],

    // Map markers
    showByIndex: null,
    currentZoomLevel: 0,
    strokeWeightPerZoomLevel: [
      5, 5, 5, 5, 5, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13,
      13, 14, 14, 15, 15,
    ],
    circleRadius: [
      5120, 5120, 5120, 5120, 5120, 5120, 5120, 5120, 2560, 1280, 640, 320, 160,
      80, 40, 17, 16, 14, 12, 10, 10, 10, 10, 10, 10, 10, 10,
    ],
  }),
  mounted() {
    this.generatePaths();
    this.$nextTick(() => {
      try {
        this.$refs.googleMaps.$mapPromise.then((map) => {
          var listener = new google.maps.event.addListener(
            map,
            "zoom_changed",
            () => {
              this.$emit("zoomLevelChanged", map.zoom);
              this.currentZoomLevel = map.zoom;
            }
          );
        });
      } catch (error) {
        console.log("Map not Ready Yet");
      }
    });
  },
  methods: {
    generatePaths() {
      this.renderLine = false;
      this.paths = [];
      this.pathsList = [];
      if (this.overlayAllData) {
        this.generatePathsProfileData();
      } else {
        if (this.normalizedData != null) {
          this.generatePathsSurveyData(
            JSON.parse(JSON.stringify(this.normalizedData))
          );
        }
      }
      this.renderLine = true;
    },
    generatePathsProfileData() {
      this.profileData.forEach((scan) => {
        let selected = false;
        if (scan.id == this.selectedMergingScan) {
          selected = true;
        }
        this.generatePathsSurveyData(
          JSON.parse(JSON.stringify(scan.normalizedData)),
          selected
        );
        this.pathsList.push(JSON.parse(JSON.stringify(this.paths)));
        this.paths = [];
      });
    },
    generatePathsSurveyData(normalizedData, selected = false) {
      let currentPaths = [];
      let currentLimit = null;
      normalizedData.forEach((path) => {
        if (selected) {
          path.highlighted = true;
        }
        if (!path.hideCircle) {
          let pathLimit =
            path.value < this.lowerLimit
              ? 1
              : path.value > this.upperLimit
              ? 3
              : 2;
          let distanceCheck = true;
          if (currentPaths.length != 0) {
            distanceCheck =
              !this.pathsMaxDistance ||
              this.getDistanceBetweenPointAPointB(
                path,
                currentPaths[currentPaths.length - 1]
              ) < this.pathsMaxDistance;
          }

          if (currentLimit == pathLimit && distanceCheck) {
            currentPaths.push(path);
          } else {
            if (currentPaths.length != 0) {
              this.paths.push(currentPaths);
              let startPath = distanceCheck
                ? currentPaths[currentPaths.length - 1]
                : path;
              startPath.value = path.value;
              currentPaths = [startPath, path];
            } else {
              currentPaths = [path];
            }

            currentLimit = pathLimit;
          }
        }
      });
      if (currentPaths.length != 0) {
        this.paths.push(currentPaths);
      }
    },
    panToLocation(position, onlyDraw = false) {
      if (!onlyDraw) {
        this.$refs.googleMaps.$mapPromise.then((map) => {
          map.panTo({ lat: position.lat, lng: position.lng });
        });
      }
      this.currentPosition = [position];
    },
    drawRangePoints(min, max) {
      this.currentRange = [min, max];
    },
    zoomToBounds(coords) {
      this.$refs.googleMaps.$mapPromise.then((map) => {
        this.$gmapApiPromiseLazy().then(() => {
          // This makes sure that the map doesn't zoom in too close for edge cases
          let threshold = 0.0025;

          if (
            Math.abs(coords.minLat - coords.maxLat) < threshold &&
            Math.abs(coords.minLng - coords.maxLng) < threshold
          ) {
            coords.minLat -= threshold;
            coords.maxLat += threshold;
            coords.minLng -= threshold;
            coords.maxLng += threshold;
          }

          let bounds = new google.maps.LatLngBounds(
            { lat: coords.minLat, lng: coords.minLng },
            { lat: coords.maxLat, lng: coords.maxLng }
          );
          map.fitBounds(bounds, 20);
        });
      });
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    lineClick(event, path) {
      let point = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };

      let currentClosest = null;
      for (let p of path) {
        if (currentClosest == null) {
          currentClosest = p;
        } else {
          if (
            this.getDistanceBetweenPointAPointB(point, currentClosest) >
            this.getDistanceBetweenPointAPointB(point, p)
          ) {
            currentClosest = p;
          }
        }
      }

      this.panToLocation(currentClosest);

      let index = this.normalizedData.findIndex((p) => {
        return p.id == currentClosest.id;
      });

      this.$emit("dotClicked", index);
    },
    getDistanceBetweenPointAPointB(a1, a2) {
      const R = 6371e3;
      const φ1 = (a1.lat * Math.PI) / 180; // φ, λ in radians
      const φ2 = (a2.lat * Math.PI) / 180;
      const Δφ = ((a2.lat - a1.lat) * Math.PI) / 180;
      const Δλ = ((a2.lng - a1.lng) * Math.PI) / 180;

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const d = R * c; // in metres
      return d;
    },
    handleClusterClick(cluster) {
      //* Extract markers id list from cluster

      const markersIdList = [];
      const gmapMarkers = cluster.getMarkers();
      gmapMarkers.forEach((m) => markersIdList.push(m.getTitle()));
      this.$refs.googleMaps.$mapPromise.then((map) => {
        if (map.zoom == 21) {
          this.$emit("showMarkers", markersIdList);
        }
      });
    },
    test(path, index, lines) {
      console.log(path, index, lines);
    },
  },
};
</script>
